/*************************************************/
/* MODAL                                         */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function modal(body, bodyLoadingClass) {
    let modals = Array.from(document.querySelectorAll('.modal')),
        modalDialogClassSelector = '.modal-dialog',
        modalContentClassSelector = '.modal-content',
        modalCloseButtonClassSelector = '.modal-close',
        utils;
    const mainContentSelector = '#mainContent',
    modalPlayerId = 'modalplayer',
    modalShowClass ='modal--show';
    let triggerElement = null;
    const videoLinkSelector = '#open-video-link';

    const init = function () {
        modalUtils();

        const videoLink = document.querySelector(videoLinkSelector);
        if (videoLink) {
            videoLink.addEventListener('click', handleVideoLinkClick);
        }

        modals.forEach(modal => {
            modal.addEventListener(customEventsNames.openModal, e => {
                if (e.detail.videoElement) {
                    utils.Video.AddVideoToModal(e.detail.modalId, e.detail.videoElement);
                } else if (e.detail.modalId && e.detail.videoId) {
                    utils.Video.AddYoutubeVideoToModal(e.detail.modalId, e.detail.videoId);
                }
            });

            modal.addEventListener(customEventsNames.videoPlayingInModal, e => {
                body.classList.remove(bodyLoadingClass);
            });

            //Close if background is clicked, but not if modalDialog is clicked
            modal.addEventListener('click', e => {
                utils.Modal.CloseModal(e.target.getAttribute('id'));
            });

            const dialog = modal.querySelector(modalDialogClassSelector);
            dialog.addEventListener('click', e => {
                e.stopPropagation();
                e.preventDefault();
            });

            modal.querySelector(modalCloseButtonClassSelector).addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                utils.Modal.CloseModal(e.target.closest('.modal').getAttribute('id'));
            });
        });


    };

    const handleVideoLinkClick = function (e) {
        e.preventDefault();

        const videoLink = e.currentTarget;
        const videoSrc = videoLink.getAttribute('href');
        const modalId = videoLink.getAttribute('data-modal-id'); 

        if (!videoSrc || !modalId) return;

        // 1. Create the HTML <video> element
        const videoElement = document.createElement('video');
        videoElement.setAttribute('controls', true);
        videoElement.setAttribute('autoplay', true); 
        videoElement.setAttribute('class', 'video-player-modal'); // Add for styling hooks

        // 2. Create the <source> element
        const source = document.createElement('source');
        source.setAttribute('src', videoSrc);
        source.setAttribute('type', 'video/mp4'); // Adjust type if video is not mp4
        videoElement.appendChild(source);

        // 3. Directly call the OpenModal function
        // Note: Since AddVideoToModal dispatches a play event, we are following the
        // established pattern of using the internal utilities for consistency.
        
        // This simulates the custom event listener logic you already have in `init`.
        const openModalEvent = new CustomEvent(customEventsNames.openModal, {
            bubbles: true,
            detail: {
                modalId: modalId,
                videoElement: videoElement 
            }
        });
        
        // Dispatch the event on the body or a root element if the existing listener is there.
        // If the listener is only on the individual modals, dispatch it there.
        // For simplicity and to ensure the modal listener catches it:
        // Dispatch it on the body, assuming the listener is set up to receive it, 
        // or directly on the target modal element.
        
        // Dispatching it on the specific modal is the safest bet since the other 
        // modal listeners are attached to individual modals.
        const targetModal = document.querySelector(modalId);
        if (targetModal) {
            targetModal.dispatchEvent(openModalEvent);
        }
    };

    function modalUtils() {
        if (!utils) {
            utils = {
            };
        }

        if (modals.length > 0) {
            utils.Modal = {
                OpenModal(modalId, content) {
                    triggerElement = document.activeElement;
                    const modal = document.querySelector(modalId);
                    body.classList.add('noscroll');
                    modal.classList.add(modalShowClass);
                    modal.querySelector(modalContentClassSelector).appendChild(content);

                    document.querySelector(mainContentSelector).setAttribute('aria-hidden', true);

                    setTimeout(() => {
                        modal.focus();
                    }, 300); //Timeout here to compensate for the transition on the modal

                },
                CloseModal(modalId, clearContent = true) {
                    modalId = `#${modalId}`;
                    const modal = document.querySelector(modalId);
                    modal.classList.remove(modalShowClass);
                    if (clearContent = true) {
                        const content = modal.querySelector(modalContentClassSelector);
                        content.removeChild(content.querySelector('#'+modalPlayerId));
                    }
                    body.classList.remove('noscroll', bodyLoadingClass);

                    const closeModalEvent = new CustomEvent(customEventsNames.closeModal, { bubbles: true });
                    modal.dispatchEvent(closeModalEvent);

                    document.querySelector(mainContentSelector).setAttribute('aria-hidden', false);

                    setTimeout(() => {
                        triggerElement.focus();
                    }, 200); //Timeout here to compensate for the keyup event needing to finish


                }
            };
        }

        utils.Video = {
            AddYoutubeVideoToModal(modalId, videoId) {
                const player = document.createElement('div');
                player.id = modalPlayerId;
                utils.Modal.OpenModal(modalId, player);
                body.classList.add(bodyLoadingClass);

                var playYoutubeVideoEvent = new CustomEvent(customEventsNames.playYoutubeVideoInModal, {
                    bubbles: true,
                    detail: {
                        modalId: modalId,
                        playerId: modalPlayerId,
                        videoId: videoId
                    }
                });

                player.dispatchEvent(playYoutubeVideoEvent);
            },
            AddVideoToModal(modalId, videoElement) {
                videoElement.id = modalPlayerId;

                utils.Modal.OpenModal(modalId, videoElement);

                body.classList.add(bodyLoadingClass);

                var playVideoEvent = new CustomEvent(customEventsNames.playVideoInModal, {
                    bubbles: true,
                    detail: {
                        modalId: modalId,
                        playerId: modalPlayerId
                    }
                });
                videoElement.dispatchEvent(playVideoEvent);

            }
        };
    }

    init();
}
